import styled from 'styled-components';
import { SkeletonBody } from '../Skeleton/styles';

export const TicketCard = styled.article`
  position: relative;
  
  display: flex;
  flex-direction: column;
  margin: 0 -10px;
  padding: 20px 10px;
  
  border-radius: 6px;
  
  transition: box-shadow 0.3s;
  
  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }
  
  @media(min-width: 1024px) {
    margin: 0 -30px;
    padding: 30px;
  }
`;

export const TicketRow = styled.div`
  display: flex;
  
  &:first-child {
    margin-bottom: 15px;
  }
  
  @media(min-width: 1024px) {
    &:first-child {
      margin-bottom: 0;
    }
    
    &:last-child {
      display: none;
    }
  }
`;

export const TicketPreview = styled.div`
  width: 63px;
  height: 63px;
  flex-shrink: 0;
  margin-right: 10px;
  
  border-radius: 6px;
  overflow: hidden;
  
  ${SkeletonBody} {
    width: 100%;
    height: 100%;
  }
  
  @media(min-width: 1024px) {
    width: 80px;
    height: 80px;
    margin-right: 25px;
  }
`;

export const TicketContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const TicketHeader = styled.header`  
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  
  ${SkeletonBody} {
    width: 100%;
    height: 10px;
  }
`;

export const TicketHeading = styled.h3`
  margin: 0;
  margin-bottom: auto;
  padding: 0;
  
  ${SkeletonBody} {
    width: 100%;
    height: 12px;
  }
  
  @media(min-width: 1024px) {
    ${SkeletonBody} {
      height: 20px;
    }
  }
`;

export const TicketPrice = styled.p`
  margin: 0;
  padding: 0;
 
  ${SkeletonBody} {
    height: 12px;
  }
  
  @media(min-width: 1024px) {
    
    ${SkeletonBody} {
      height: 20px;
    }
  }
`;
